import { Paper, Stack } from '@mantine/core';
import type { FC, ReactNode } from 'react';

export const Panel: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Paper bg="gigi-white" radius={24} shadow="xl" w={720}>
      <Stack gap="sm" px="xl" py="lg">
        {children}
      </Stack>
    </Paper>
  );
};
